import axios from "axios";
import ApiException from "./ApiException";
import config from "@/app.config.json";
import { getToken } from "@/utils/funcoes";

const urlBase = `${config.urlApi}/Dashboard`;

export interface PrevisaoMes {
  mes: string;
  previsto: number;
  recebido: number;
}

export interface ItemMes {
  mes: string;
  qtde: number;
}

export interface ItemValor {
  nome: string;
  valor: number;
}

export interface Dashboard {
  totalRecebidoMes: number;
  totalAReceberMes: number;
  totalAtrasado: number;
  qtdeParcelasAtrasadas: number;
  qtdeContratosAtivos: number;
  qtdeClientesAtivos: number;
  qtdeClientesNovosMes: number;
  previsaoMensal: PrevisaoMes[];
  novosClientesPorMes: ItemMes[];
  situacaoMensalidadesMes: ItemValor[];
  topCidades: ItemValor[];
}

export const obter = (): Promise<Dashboard> => {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common.Authorization = getToken();
    axios
      .get(urlBase)
      .then((r) => resolve(r.data))
      .catch((e) => reject(new ApiException(e || "Falha ao obter dashboard")));
  });
};
